<div tabindex="0" class="me-sr-success-card row" *ngIf="data">
    <div class="me-sr-success-card__icon">
        <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2273_23506)"><rect width="56" height="56" transform="translate(0.5)" fill="white"></rect><circle cx="28.5001" cy="27.9999" r="27.88" fill="#B7ECDC"></circle><path d="M37.7254 18.7742L25.35 36.4525C25.1867 36.6872 24.97 36.8796 24.7177 37.0141C24.4655 37.1485 24.1849 37.2211 23.899 37.2258C23.6132 37.2306 23.3304 37.1673 23.0738 37.0413C22.8173 36.9152 22.5943 36.73 22.4234 36.5009L19.2754 32.3042" stroke="#202A4D" stroke-width="1.23" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_2273_23506"><rect width="56" height="56" fill="white" transform="translate(0.5)"></rect></clipPath></defs></svg>
    </div>
    <div class="me-sr-success-card__header">
        {{data.title}}
    </div>
    <div class="me-sr-success-card__description" [innerHTML]="data.text | storyblokRichtext">
    </div>
    <div class="me-sr-success-card__button">
        <button class="btn btn--primary" (click)="next()">
            {{ 'Go to dashboard' | translate}}
        </button>
    </div>
</div>